import styled from 'styled-components';
import { getColorAlias, getFontSize, getSpacing } from '../../utils/index.js';

const Wrapper = styled.div `
  display: flex;
  position: relative;
  background: ${getColorAlias('containerStrong')};
  border-radius: ${({ theme }) => theme.radius.roundedE};
  padding: 2px;
  width: fit-content;
  font-weight: ${(props) => props.theme.font.weightBold};
  font-family: ${(props) => props.theme.font.familyPrimary};
  ${getFontSize('size14')};
  height: ${(props) => props.height}px;
`;
const Indicator = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: ${(props) => props.width}px;
  left: ${(props) => props.left}px;
  height: ${(props) => props.height}px;
  max-height: ${(props) => props.height}px;
  bottom: 2px;
  border-radius: ${({ theme }) => theme.radius.roundedE};
  background-color: ${getColorAlias('interactiveLight')};
  box-shadow: ${(props) => props.theme.elevation.e3};
  color: ${getColorAlias('contentInteractiveDark')};
  transition: ${({ theme }) => `${theme.motion.speed.exitM} ${theme.motion.easing.easeDefault}`};

  svg {
    margin-right: ${getSpacing('s01')};
    vertical-align: middle;
  }
`;

export { Indicator, Wrapper };
